export default __webpack_public_path__ + "static/summer_containers88-b2dcbb002638ac6cef5edc8b1afc4644.webp";